import { Overrides } from '@material-ui/core/styles/overrides';

export const initializeListOverrides = (config?: Overrides['MuiList']): Overrides['MuiList'] => {
  return {
    root: {},
    padding: {},
    ...config,
  };
};
